


















import Vue from 'vue';
import PipelineMenu from './PipelineMenu/PipelineMenu.vue';
import steps from '@/pipeline/steps';
import i18n from '@/i18n';
import pipeline from '@/pipeline';
import { Provider } from '@/helpers/accountsIframe';
import { showEqualWebDrawer } from '@/helpers/accessibility';
import Analytics from '@/helpers/analytics';
import ChangeCourseCampus from './ChangeCourseCampus.vue';

interface PipelineItem {
  title: string;
  steps: string[];
  childrenActive: boolean;
  children: { title: string; steps: string[] }[];
}

export default Vue.extend({
  components: { PipelineMenu, ChangeCourseCampus },
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { pipelineItems: [] as PipelineItem[], currentStep: '', stepHistory: [] as string[] };
  },
  computed: {
    studentEmailHasAccounts(): boolean {
      return this.$store.getters.studentEmailHasAccounts || false;
    },
    studentEmailProviders(): Provider[] {
      return this.$store.getters.studentEmailProviders || [];
    },
    studentAccountsHasSocialLogin(): boolean {
      const { GOOGLE, FACEBOOK, APPLE } = Provider;
      return this.studentEmailProviders.some((provider: Provider) =>
        [GOOGLE, FACEBOOK, APPLE].includes(provider),
      );
    },
    currentAccountsStatus(): 'signIn' | 'signUp' | 'signInSocial' {
      if (this.studentEmailHasAccounts) {
        return 'signIn';
      }
      return 'signUp';
    },
  },
  mounted() {
    const forceTrigger = pipeline.initialized;
    pipeline.addTransitionListener(this.onPipelineUpdate, forceTrigger);
  },
  beforeDestroy() {
    pipeline.removeTransitionListener(this.onPipelineUpdate);
  },
  methods: {
    goToStep(step: string) {
      if (pipeline.initialized) pipeline.goTo(step);
    },
    onPipelineUpdate() {
      if (!pipeline.initialized) return;

      const myDataItem: PipelineItem = {
        title: i18n.t('pipelineMenuOptions.myData'),
        childrenActive: false,
        steps: [
          steps.personalData,
          steps.address,
          steps.identificationDocument,
          steps.academicFormation,
        ],
        children: [
          { title: i18n.t('pipelineMenuOptions.personalData'), steps: [steps.personalData] },
          { title: i18n.t('pipelineMenuOptions.address'), steps: [steps.address] },
          {
            title: i18n.t('pipelineMenuOptions.identificationDocument'),
            steps: [steps.identificationDocument],
          },
          {
            title: i18n.t('pipelineMenuOptions.academicFormation'),
            steps: [steps.academicFormation],
          },
        ],
      };

      const { hasFinancialSponsor } = pipeline.state.context;

      if (hasFinancialSponsor) {
        myDataItem.steps.push(
          steps.financialSponsor.personalData,
          steps.financialSponsor.identificationDocument,
          steps.financialSponsor.address,
        );

        myDataItem.children.push(
          {
            title: i18n.t('pipelineMenuOptions.financialSponsor.personalData'),
            steps: [steps.financialSponsor.personalData],
          },
          {
            title: i18n.t('pipelineMenuOptions.financialSponsor.identificationDocument'),
            steps: [steps.financialSponsor.identificationDocument],
          },
          {
            title: i18n.t('pipelineMenuOptions.financialSponsor.address'),
            steps: [steps.financialSponsor.address],
          },
        );
      }

      const documentsItem: PipelineItem = {
        title: i18n.t('pipelineMenuOptions.documents'),
        childrenActive: false,
        steps: [steps.documents],
        children: [],
      };

      const contractItem: PipelineItem = {
        title: i18n.t('pipelineMenuOptions.contract'),
        childrenActive: false,
        steps: [steps.contract],
        children: [],
      };

      const paymentItem: PipelineItem = {
        title: i18n.t('pipelineMenuOptions.payment'),
        childrenActive: false,
        steps: [steps.payment],
        children: [],
      };

      const createAccountItem: PipelineItem = {
        title: i18n.t(`pipelineMenuOptions.${this.currentAccountsStatus}`),
        childrenActive: false,
        steps: [steps.accounts],
        children: [],
      };

      this.pipelineItems = [
        myDataItem,
        documentsItem,
        contractItem,
        paymentItem,
        createAccountItem,
      ];
      this.currentStep = pipeline.currentStep;
      this.stepHistory = pipeline.state.context.history || [];
    },
    onAccessibilityButtonClick() {
      Analytics.track('Open accessibility drawer', {
        origin: 'Botão Acessibilidade',
      });

      showEqualWebDrawer();
    },
  },
});
